import React, { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import {
  faSquarePhoneFlip,
  faPhoneVolume,
  faMessage,
  faSitemap,
  faFileAudio,
  faMicrophone,
  faFileWaveform,
  faCalendarAlt,
  faHandshake,
  faArrowsUpDownLeftRight,
  faMusic,
  faCogs,
  faClipboardList,
  faChartLine,
  faClock,
  faSyncAlt,
} from "@fortawesome/free-solid-svg-icons";
import AboutImage from "../../assets/about/abouthero.webp";
import AOS from "aos";
import "aos/dist/aos.css";
function Feature() {
  const fCards = [
    {
      id: "1",
      icon: faSquarePhoneFlip,
      heading: "DID Number",
      description:
        "Get unique virtual numbers to manage business calls professionally.",
      // color: "#FF5733",
      color: "#ff6b14",
    },
    {
      id: "2",
      icon: faPhoneVolume,
      heading: "Call Forwarding",
      description:
        "Redirect incoming calls to alternate numbers to ensure zero missed calls.",
      // color: "#28A745",
      color: "#ff6b14",
    },
    {
      id: "3",
      icon: faMessage,
      heading: "Greeting Message",
      description: "Welcome customers with personalized voice greetings.",
      // color: "#FFC107",\
      color: "#ff6b14",
    },
    {
      id: "4",
      icon: faSitemap,
      heading: "Multilevel IVR",
      description:
        "Route callers to the right department using smart IVR options.",
      // color: "#0040ff",
      color: "#ff6b14",
    },
    {
      id: "5",
      icon: faFileAudio,
      heading: "Audio File Upload",
      description:
        "Upload custom audio for greetings, announcements, or promotions.",
      // color: "#ff00ff",
      color: "#ff6b14",
    },
    {
      id: "6",
      icon: faMicrophone,
      heading: "Call Recording",
      description:
        "Record and store conversations for quality and training purposes.",
      // color: "#bfff00",
      color: "#ff6b14",
    },
    {
      id: "7",
      icon: faFileWaveform,
      heading: "Text to Speech",
      description:
        "Convert written messages to speech for automated voice responses.",
      // color: "#ff0040",
      color: "#ff6b14",
    },
    {
      id: "8",
      icon: faCalendarAlt,
      heading: "Time Based Routing",
      description:
        "Route calls based on business hours and agent availability.",
      // color: "#FF5733",
      color: "#ff6b14",
    },
    {
      id: "9",
      icon: faHandshake,
      heading: "Sticky Agent",
      description:
        "Ensure repeated callers are always connected to the same agent.",
      // color: "#28A745",
      color: "#ff6b14",
    },
    {
      id: "10",
      icon: faArrowsUpDownLeftRight,
      heading: "Automatic Call Distribution",
      description:
        "Distribute calls to available agents efficiently and fairly.",
      // color: "#bfff00",
      color: "#ff6b14",
    },
    {
      id: "11",
      icon: faMusic,
      heading: "Music on Hold",
      description: "Play pleasant music to keep callers engaged while on hold.",
      // color: "#ff00ff",
      color: "#ff6b14",
    },
    {
      id: "12",
      icon: faCogs,
      heading: "Custom Audio",
      description:
        "Customize your IVR audio to match your brand's tone and voice.",
      // color: "#FFC107",
      color: "#ff6b14",
    },
    {
      id: "13",
      icon: faClipboardList,
      heading: "Survey Missed Call",
      description: "Collect feedback or trigger actions via missed calls.",
      // color: "#FFC107",
      color: "#ff6b14",
    },
    {
      id: "14",
      icon: faChartLine,
      heading: "Reports & Analytics",
      description: "Track performance with detailed call logs and analytics.",
      // color: "#0040ff",
      color: "#ff6b14",
    },
    {
      id: "15",
      icon: faClock,
      heading: "Wait Time-based Distribution",
      description:
        "Reduce wait time by auto-routing to the next available agent.",
      // color: "#ff0040",
      color: "#ff6b14",
    },
    {
      id: "16",
      icon: faSyncAlt,
      heading: "Real-time Dashboards",
      description:
        "Monitor live call activities and agent performance instantly.",
      // color: "#28A745",
      color: "#ff6b14",
    },
  ];

  // for the aos libabry

  useEffect(() => {
    AOS.init({
      duration: 1000, // animation duration
      once: true, // animation happens only once on scroll
    });
  }, []);
  return (
    <div>
      <div className="relative w-full h-[60vh] md:h-[70vh] bg-black">
        {/* Background image */}
        <div className="absolute inset-0">
          <img
            src={AboutImage}
            alt="About3"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        </div>

        {/* Content */}
        <div className="relative z-10 flex flex-col justify-center items-start h-full px-6 md:px-16 text-white">
          <h1 className="text-3xl md:text-4xl font-bold mb-4">Our Feature</h1>
          <div className="flex items-center space-x-2 text-sm md:text-base">
            <Link to="/" className="text-white hover:underline font-bold">
              Home
            </Link>
            <span className="text-orangeheading">●</span>
            <span className="text-gray-300">Features</span>
          </div>
        </div>
      </div>

      <div className="bg-[#F5F6F9]">
        <div className="py-10 md:px-7 px-5">
          {/* Section Title */}
          <h2 className="text-2xl sm:text-3xl font-semibold text-center mt-4 mb-2 text-orangeheading">
            Features of IVR System
          </h2>
          <div className="md:w-32 w-20 h-1 bg-orangeheading mx-auto mb-10 rounded-full" />

          {/* Cards Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {fCards?.map(
              ({ icon, color, heading, description, link }, index) => (
                <div
                  key={index}
                  className="bg-[#00aeff] shadow-md hover:shadow cursor-pointer transition-shadow duration-300 rounded-xl p-6 flex flex-col justify-between h-full"
                  data-aos="fade-up"
                  data-aos-delay={index * 100} // Optional: staggered animation
                >
                  <div className="text-center">
                    <div className="w-20 h-20 mx-auto mb-4 rounded-full bg-[#e0ecff] flex items-center justify-center">
                      <FontAwesomeIcon
                        icon={icon}
                        className="text-4xl"
                        style={{ color }}
                      />
                    </div>
                    <h5 className="md:text-lg text-base font-semibold mb-2 text-white">
                      {heading}
                    </h5>
                    <p className="text-sm text-white">{description}</p>
                  </div>
                </div>
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Feature;
